import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DisplayScreen from './display/DisplayScreen';
import StageScreen from './display/StageScreen';
import RemoteScreen from './remote/RemoteScreen';
import ObsScreen from './remote/ObsScreen';
import UpdateBanner from './components/UpdateBanner';
import { DISPLAY_PATH, STAGE_PATH } from './display/displayChannel';
import { REMOTE_PATH, OBS_PATH } from './remote/remoteProtocol';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installNetworkErrorGuard } from './lib/networkErrors';
import reportWebVitals from './reportWebVitals';

// Dropped connections are normal for a church app; they must not throw up an
// error screen. Only network-failure rejections are filtered, nothing else.
installNetworkErrorGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {window.location.pathname === DISPLAY_PATH ? <DisplayScreen />
      : window.location.pathname === STAGE_PATH ? <StageScreen />
      : window.location.pathname === REMOTE_PATH ? <RemoteScreen />
      : window.location.pathname === OBS_PATH ? <ObsScreen />
      : (
        <>
          <App />
          <UpdateBanner />
        </>
      )}
  </React.StrictMode>
);

// Lets the app (and /display, /stage) load with no network. Production only.
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
